module.exports = __webpack_public_path__ + "static/media/0008.4ac0de8d.jpg";